import React from 'react';
import AddImagingOrder from '../components/AddImagingOrder';

const ImagingOrderFormPage: React.FC = () => <AddImagingOrder />;

export default ImagingOrderFormPage;
